import request from './request'

export default {
  list(data) {
    return request.post('/vipCardCategory/list', data)
  },
  info(data) {
    return request.post('/vipCardCategory/info', data)
  },
  save(data) {
    return request.post('/vipCardCategory/save', data)
  },
  enable(data) {
    return request.post('/vipCardCategory/enable', data)
  },
  disable(data) {
    return request.post('/vipCardCategory/disable', data)
  },
  forbidden(data) {
    return request.post('/vipCardCategory/forbidden', data)
  },
  delete(data) {
    return request.post('/vipCardCategory/delete', data)
  },
}
